/* Menu mobile JOUBERT (snippets/joubert-menu.liquid). */
(() => {
  const menu = document.getElementById('jb-menu');
  const bouton = document.querySelector('[data-jb-menu-bouton]');
  if (!menu || !bouton) return;

  // Hors de l'en-tête : sa section est transformée (masquage au défilement),
  // ce qui piégerait un élément en position fixe.
  document.body.appendChild(menu);
  menu.hidden = false;

  const racine = document.documentElement;
  const entete = document.querySelector('.shopify-section--header');
  const barre = entete && entete.querySelector('.header');
  const principal = menu.querySelector('.jb-menu__principal');
  const plateau = menu.querySelector('.jb-menu__plateau');
  let actif = null;
  let etaitSolide = false;
  let clavier = false;
  addEventListener('keydown', (e) => { if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') clavier = true; }, true);
  addEventListener('pointerdown', () => { clavier = false; }, true);
  const focaliser = (el) => { if (clavier && el) el.focus({ preventScroll: true }); };

  const estOuvert = () => menu.classList.contains('jb-menu--ouvert');

  const ouvrir = () => {
    const bas = entete ? entete.getBoundingClientRect().bottom : 0;
    menu.style.setProperty('--jb-menu-haut', Math.max(0, bas) + 'px');
    if (barre) { etaitSolide = barre.classList.contains('is-solid'); barre.classList.add('is-solid'); }
    racine.classList.add('jb-menu-ouvert');
    if (principal.classList.contains('is-recherche')) racine.classList.add('jb-menu-recherche');
    menu.classList.add('jb-menu--ouvert');
    bouton.setAttribute('aria-expanded', 'true');
    menu.removeAttribute('inert');
  };

  const fermer = () => {
    racine.classList.remove('jb-menu-ouvert', 'jb-menu-recherche');
    menu.classList.remove('jb-menu--ouvert');
    bouton.setAttribute('aria-expanded', 'false');
    menu.setAttribute('inert', '');
    if (barre && !etaitSolide) barre.classList.remove('is-solid');
    setTimeout(() => { if (!estOuvert()) fermerSous(); }, 450);
  };

  const ouvrirSous = (id, declencheur) => {
    const panneau = document.getElementById(id);
    if (!panneau) return;
    actif = panneau;
    panneau.scrollTop = 0;
    panneau.classList.add('is-actif');
    principal.classList.add('is-recule');
    if (declencheur) declencheur.setAttribute('aria-expanded', 'true');
    const retour = panneau.querySelector('[data-jb-menu-retour]');
    if (retour) setTimeout(() => focaliser(retour), 300);
  };

  const fermerSous = () => {
    if (!actif) return;
    const declencheur = menu.querySelector(`[data-jb-menu-ouvre="${actif.id}"]`);
    actif.style.transform = '';
    principal.style.transform = '';
    principal.style.opacity = '';
    actif.classList.remove('is-actif', 'is-suit');
    principal.classList.remove('is-recule', 'is-suit');
    actif = null;
    if (declencheur) { declencheur.setAttribute('aria-expanded', 'false'); if (estOuvert()) focaliser(declencheur); }
  };

  menu.setAttribute('inert', '');
  bouton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    bouton.classList.toggle('is-clavier', clavier);
    estOuvert() ? fermer() : ouvrir();
  }, true);
  menu.addEventListener('click', (e) => {
    const cible = e.target.closest('[data-jb-menu-ouvre], [data-jb-menu-retour], [data-jb-menu-fermer]');
    if (!cible) return;
    if (cible.hasAttribute('data-jb-menu-ouvre')) ouvrirSous(cible.dataset.jbMenuOuvre, cible);
    else if (cible.hasAttribute('data-jb-menu-retour')) fermerSous();
    else fermer();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !estOuvert()) return;
    actif ? fermerSous() : (fermer(), focaliser(bouton));
  });
  matchMedia('(min-width: 700px)').addEventListener('change', (m) => { if (m.matches && estOuvert()) fermer(); });
  // un lien vers une ancre de la page courante : on referme
  menu.addEventListener('click', (e) => { if (e.target.closest('a[href^="#"]')) fermer(); });

  // Recherche instantanée, comme celle de l'en-tête sur ordinateur (section predictive-search du thème).
  const champ = menu.querySelector('.jb-menu__recherche input[name="q"]');
  const resultats = menu.querySelector('.jb-menu__resultats');
  if (champ && resultats) {
    let minuterie = null, requete = null;
    const effacer = menu.querySelector('.jb-menu__effacer');
    const vider = () => {
      if (requete) requete.abort();
      resultats.hidden = true;
      resultats.replaceChildren();
      principal.classList.remove('is-recherche');
      racine.classList.remove('jb-menu-recherche');
    };
    effacer.addEventListener('click', () => {
      champ.value = '';
      effacer.hidden = true;
      vider();
      champ.focus();
    });
    const chercher = async () => {
      const q = champ.value.trim();
      if (q.length < 2) { vider(); return; }
      if (requete) requete.abort();
      requete = new AbortController();
      try {
        const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[limit]=10&resources[limit_scope]=each`;
        const html = await (await fetch(url, { signal: requete.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.shopify-section');
        if (!section || champ.value.trim() !== q) return;
        resultats.replaceChildren(...document.importNode(section, true).children);
        resultats.hidden = false;
        principal.classList.add('is-recherche');
        racine.classList.add('jb-menu-recherche');
      } catch (e) { /* requête remplacée par une frappe plus récente */ }
    };
    resultats.addEventListener('click', (e) => {
      const envoi = e.target.closest('button[type="submit"], [form]');
      if (!envoi) return;
      e.preventDefault();
      champ.form.requestSubmit ? champ.form.requestSubmit() : champ.form.submit();
    });
    champ.addEventListener('input', () => {
      clearTimeout(minuterie);
      effacer.hidden = !champ.value;
      if (!champ.value.trim()) { vider(); return; }
      minuterie = setTimeout(chercher, 250);
    });
  }

  // Glisser vers la droite pour sortir d'un sous-menu : le panneau suit le doigt.
  let x0 = null, y0 = 0, dx = 0, t0 = 0, horizontal = null;
  plateau.addEventListener('touchstart', (e) => {
    if (!actif) return;
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; t0 = Date.now(); horizontal = null;
  }, { passive: true });
  plateau.addEventListener('touchmove', (e) => {
    if (x0 === null || !actif) return;
    const mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
    if (horizontal === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) horizontal = Math.abs(mx) > Math.abs(my);
    if (!horizontal) return;
    dx = Math.max(0, mx);
    const k = dx / plateau.clientWidth;
    actif.classList.add('is-suit'); principal.classList.add('is-suit');
    actif.style.transform = `translateX(${dx}px)`;
    principal.style.transform = `translateX(${-22 * (1 - k)}%)`;
    principal.style.opacity = String(.4 + .6 * k);
  }, { passive: true });
  const lacher = () => {
    if (x0 === null || !actif) { x0 = null; return; }
    const vitesse = dx / Math.max(1, Date.now() - t0);
    actif.classList.remove('is-suit'); principal.classList.remove('is-suit');
    if (horizontal && (dx > plateau.clientWidth * .3 || vitesse > .5)) fermerSous();
    else { actif.style.transform = ''; principal.style.transform = ''; principal.style.opacity = ''; }
    x0 = null;
  };
  plateau.addEventListener('touchend', lacher);
  plateau.addEventListener('touchcancel', lacher);
})();
